import Link from "next/link";
import * as React from "react";
import Image from "next/image";
import styles from "./../styles.module.css";
import { HandsetDeal } from "@/types/index";

const SIMOnlyDeal: React.FC<{
	data: HandsetDeal;
	urlReference?: string;
	onDealClick?: (product: HandsetDeal) => void;
}> = ({ data, urlReference, onDealClick }) => {
	const getUrl = () => {
		return !urlReference ? data.url : `${data.url}&pref1=${urlReference}`;
	};

	const sellingPoints = [
		{
			src: "/icons/wifi.svg",
			title:
				data.data_allowance === "UNLIMITED" ? (
					<>Unlimited</>
				) : (
					<>{Number(data.data_allowance) / 1000}GB</>
				),
			description: "Data",
		},
		{
			src: "/icons/sellingPointCalendar.svg",

			title: data.contract_length,
			description: "Month Contract",
		},
		{
			src: "/icons/clock.svg",
			title:
				data.minutes_allowance === "UNLIMITED" ? (
					<>Unlimited</>
				) : (
					<>{Number(data.minutes_allowance)}</>
				),
			description: "Minutes",
		},
		{
			src: "/icons/text.svg",
			title:
				data.texts_allowance === "UNLIMITED" ? (
					<>Unlimited</>
				) : (
					<>{Number(data.texts_allowance)}</>
				),
			description: "Texts",
		},
		{
			src: "/icons/sellingPointMoney.svg",
			title: `£${data.monthly_price}`,
			description: "Monthly cost",
		},
	];

	return (
		<div
			className={`${styles.deal__container} mb-5 row ms-lg-5 pt-1 pt-md-4 pb-3 pb-md-4 `}
		>
			<div className={`col-12 col-md-12 pe-md-4  pe-4 pe-md-0 ps-4`}>
				<div className={styles["deal__provider-header"]}>
					<div className={styles["deal__provider-header-content"]}>
						<div className={`${styles.deal__icon} d-flex align-items-center`}>
							<Image
								src={data.image_url ?? ""}
								alt=""
								fill
								objectFit="contain"
							/>
						</div>

						<h3 className={`${styles.deal__title} mt-2 mt-sm-0 `}>
							{data.network}
						</h3>
					</div>
				</div>
				<div className={`${styles["deal__selling-points"]} flex-wrap pt-4 `}>
					{sellingPoints.map((point, index) => (
						<div
							key={index}
							className={`${styles["deal__selling-points-box"]} text-center text-md-start`}
						>
							<div className="text-end">
								<Image src={point.src} alt="icon" width={22} height={22} />
							</div>
							<h3
								className={`${styles["deal__selling-points-title"]} text-center`}
							>
								{point.title}
							</h3>
							<p className={`mb-0 text-center ${styles.deal__description}`}>
								{point.description}
							</p>
						</div>
					))}
				</div>
			</div>

			<div className=" mt-3  d-flex justify-content-center justify-content-md-end">
				<Link
					onClick={() => (onDealClick !== undefined ? onDealClick(data) : null)}
					href={getUrl()}
					target="_blank"
					rel="noreferrer"
					id={`BB-${data.network}`}
					className={`${styles["broadband-affiliate__button"]} button d-flex align-items-center text-decoration-none`}
				>
					See Deal
				</Link>
			</div>
		</div>
	);
};

export default SIMOnlyDeal;
